export default {"src":"/_next/static/media/gcp-icon.f5e6fb36.svg","height":24,"width":31};